import React from 'react';
import { Box, Typography } from '@mui/material';
import { GoAlertFill } from "react-icons/go";


const Alert = ({ onClick, title, count }) => {
  return (
    <Box display="flex" gap={1} alignItems="center" border="1px solid #D95040" bgcolor="#FFF6ED" borderRadius={1} padding="6px 12px">
      <GoAlertFill style={{ fontSize: '16px', color: '#D95040' }} />
      <Typography fontSize={12} color="#D95040" fontWeight={400} lineHeight="20px">{title}</Typography>
      {count && <Typography fontSize={10} fontWeight={400} color="#FF9900" width={20} height={20} display="flex" alignItems="center" justifyContent="center" border="1px solid #FF9900" borderRadius="100%" lineHeight={'20px'} paddingInline={'4px'} >{count}</Typography>}
      <Typography onClick={onClick} fontSize={12} fontWeight={700} color="#1565D8" lineHeight="13px" marginLeft="4px" borderBottom="1px solid #1565D8 ">Please Resolve The Issue</Typography>
    </Box>
  )
}

export default Alert
